import { SET_SELECTED_SAMPLE_ID } from './types';

export const setSelectedSampleId = selectedSampleId => ({
  type: SET_SELECTED_SAMPLE_ID, selectedSampleId
});
